import { Injectable } from '@angular/core';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { dictionaryBooking } from 'src/models/languageBooking';
import { exportFilesCustomStylesIncadea } from './CustomStyles/exportFilesCustomStylesIncadea';
import { exportFilesCustomStyles } from './CustomStyles/exportFilesCustomStyles';
import { ViewType } from 'src/app/enums/viewType.enum';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from './helperService';
import { environment } from 'src/environments/environment';
import { brandData } from './api-services/api-interfaces/brands.interface';
@Injectable({
  providedIn: 'root',
})
export class PublicSiteConfig {
  private ApiURL: string = "";
  constructor(private router: Router,private http: HttpClient, private helperService: HelperService) {
    this.ApiURL = environment.brandsUrl + 'brands/';
  }
  // Get the dictionary of different languages
  public language: dictionaryBooking[] = [
    {
      nameLanguage: 'Spanish',
      codeLanguage: 'es-CO',
    },

    {
      nameLanguage: 'English',
      codeLanguage: 'en-US',
    },

    {
      nameLanguage: 'French Belgium',
      codeLanguage: 'fr-BE',
    },

    {
      nameLanguage: 'Dutch',
      codeLanguage: 'du-BE',
    },
  ];

  // start look and feel webview booking

  public getPublicSiteConfig (indexBrand: number, indexCountry: number, webviewType: ViewType): LookAndFeelWebView {
    const customStylesFiles = webviewType === ViewType.Incadea ? exportFilesCustomStylesIncadea : exportFilesCustomStyles;

    if(this.helperService.filterType === "Retail")indexBrand = 8
    if (!indexCountry || !indexBrand) {
      return {} as LookAndFeelWebView; 
    }

    if((!customStylesFiles[indexCountry] || !customStylesFiles[indexCountry][indexBrand]) && indexCountry!=1) {
      this.router.navigate(['WebView/404']);
      return {} as LookAndFeelWebView; 
    }

    return customStylesFiles[indexCountry][indexBrand]();
  }

  public getPublicBrandData(countryId?: number,brandId?: number,countryName?: string): Observable<any> {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${this.helperService.TokenBooking}`,
        });
        const options = { headers };
        return this.http.post<brandData>(`${this.ApiURL}GetFilterTypeBrandData`, { countryId,brandId,countryName }, options)
      }

  public webview: LookAndFeelWebView[] = [
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'Hino',
      logo: 'Hino-logo.png',
      sublogo: 'hino-sublogo.png',
      primaryColor: '#D72729',
      secondaryColor: '#D72729',
      tertiaryColor: '#EEC3C4',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/hino-banner-1.png',
      imagen_banner2: '/assets/hino-banner-2.png',
      radius: '0px',
      radiuscontainer: '0px',
      FontType: 'Helvetica',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'Helvetica',
      button2: '',
      buttonClear: '#666666',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#666666',
      buttonSearch: '#D72729',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#666666',
      buttonBackgroundColor: '#666666',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#D72729',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#000000',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#D72729',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#666666',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'Montserrat',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'Subaru',
      logo: 'subaru-logo.png',
      sublogo: 'subaru-sublogo.png',
      primaryColor: '#00A0DC',
      secondaryColor: '#00A0DC',
      tertiaryColor: '#CCE9FF',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/imgBanner.png',
      imagen_banner2: '/assets/img-banner-subaru2.png',
      radius: '0rem',
      radiuscontainer: '0rem',
      FontType: 'Avenir Next LT Pro',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'Avenir Next LT Pro',
      button2: '',
      buttonClear: '#00A0DC',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#00A0DC',
      buttonSearch: '#00A0DC',
      buttonSearchBorder: '#00A0DC',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#00A0DC',
      buttonBackgroundColor: '#00A0DC',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#00A0DC',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#00A0DC',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#00A0DC',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#00A0DC',
      cancelMessageFontType: 'Avenir Next LT Pro',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'DFSK',
      logo: 'dfsk-logo.png',
      sublogo: 'dfsk-sublogo.png',
      primaryColor: '#BF0811',
      secondaryColor: '#BF0811',
      tertiaryColor: '#ECB5B8',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/imagen_banner_dfsk.png',
      imagen_banner2: '/assets/Dfsk-banner-2.jpg',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'Montserrat-Regular',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'Montserrat-Regular',
      button2: '',
      buttonClear: '#666666',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#666666',
      buttonSearch: '#BF0811',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#666666',
      buttonBackgroundColor: '#666666',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#BF0811',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#000000',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#BF0811',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#666666',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'Montserrat',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'BMW',
      logo: 'bmw-logo.png',
      sublogo: 'bmw-sublogo.png',
      primaryColor: '#1C69D4',
      secondaryColor: '#1C69D4',
      tertiaryColor: '#1C69D1',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/imagen_banner_bmw.png',
      imagen_banner2: '/assets/imagen_banner_bmw2.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'BMWTypeNextTT-Regular',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'BMWTypeNextTT-Regular',
      button2: '',
      buttonClear: '#4D4D4D',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#4D4D4D',
      buttonSearch: '#1C69D4',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#4D4D4D',
      buttonBackgroundColor: '#4D4D4D',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#1C69D4',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#000000',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#1C69D4',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#4D4D4D',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'BMWTypeNextTT-Regular',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'MINI',
      logo: 'bmw-logo.png',
      sublogo: 'bmw-sublogo.png',
      primaryColor: '#0085AC',
      secondaryColor: '#000',
      tertiaryColor: '#1C69D1',
      neutralColor: '#F2F2F2',
      imagen_banner: '/assets/imagen_banner_mini.png',
      imagen_banner2: '/assets/imagen_banner_mini.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'Georgia',
      StyleLookAndFeel: 'Style2',
      FontColor: '#000000',
      SecundaryFontType: 'MINI Serif-Regular',
      button2: '#0085AC',
      buttonClear: '#000',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#000',
      buttonSearch: '#0085AC',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#ffff',
      buttonBorderColor: '#000',
      buttonBackgroundColor: '#000',
      fontButtonColor: '#ffff',
      buttonColor: '#ffff',
      nextButtonColor: '#0085AC',
      nextButtonFont: '#ffff',
      backButtonFont: '#ffff',
      backButtonColor: '#0085AC',
      bannerBackgroundColor: '#F2F2F2',
      bannerBackgroundColorText: '#000',
      cancelBackButtonBackground: '#000',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'Georgia',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'BMW Motorrad',
      logo: 'bmw-logo.png',
      sublogo: 'bmw-sublogo.png',
      primaryColor: '#1C69D4',
      secondaryColor: '#1C69D4',
      tertiaryColor: '#1C69D1',
      neutralColor: '#F2F2F2',
      imagen_banner: '/assets/imagen_banner_motoRad.png',
      imagen_banner2: '/assets/imagen_banner_motoRad.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'BMW Motorrad',
      StyleLookAndFeel: 'Style2',
      FontColor: '#000',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '#Ffff',
      buttonClearFontColor: '#000',
      buttonClearBorder: '#000',
      buttonSearch: '#000',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#Ffff',
      buttonBorderColor: '#000',
      buttonBackgroundColor: '#Ffff',
      fontButtonColor: '#000',
      buttonColor: '#Ffff',
      nextButtonColor: '#000',
      nextButtonFont: '#Ffff',
      backButtonFont: '#Ffff',
      backButtonColor: '#000',
      bannerBackgroundColor: '#F2F2F2',
      bannerBackgroundColorText: '#000',
      cancelBackButtonBackground: '#Ffff',
      cancelBackButtonText: '#000',
      cancelMessageFontType: 'BMW Motorrad',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'BYD',
      logo: 'BYD-logo.png',
      sublogo: 'BYD-sublogo.png',
      primaryColor: '#E80000',
      secondaryColor: '#252728',
      tertiaryColor: '#62686B',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/imagen_banner_byd.png',
      imagen_banner2: '/assets/imagen_banner_byd.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'Montserrat-Regular',
      StyleLookAndFeel: 'Style2',
      FontColor: '#000',
      SecundaryFontType: 'MontserratBYD',
      button2: '#E80000',
      buttonClear: '#000',
      buttonClearFontColor: '#Ffff',
      buttonClearBorder: '#000',
      buttonSearch: '#E80000',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#Ffff',
      buttonBorderColor: '#000',
      buttonBackgroundColor: '#000',
      fontButtonColor: '#Ffff',
      buttonColor: '#Ffff',
      nextButtonColor: '#E80000',
      nextButtonFont: '#Ffff',
      backButtonFont: '#Ffff',
      backButtonColor: '#E80000',
      bannerBackgroundColor: '#F1F1F1',
      bannerBackgroundColorText: '#000',
      cancelBackButtonBackground: '#000',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'Montserrat',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'DERCO',
      logo: 'derco-logo.svg',
      sublogo: 'derco-sublogo.svg',
      primaryColor: '#DC241F',
      secondaryColor: '#DC241F',
      tertiaryColor: '#62686B',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/derco_banner_1.jpg',
      imagen_banner2: '/assets/derco_banner_2.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'lato',
      StyleLookAndFeel: 'Style1',
      FontColor: '#fff',
      SecundaryFontType: 'lato',
      button2: '#DC241F',
      buttonClear: '#fff',
      buttonClearFontColor: '#DC241F',
      buttonClearBorder: '#DC241F',
      buttonSearch: '#DC241F',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#fff',
      buttonBorderColor: '#DC241F',
      buttonBackgroundColor: '#fff',
      fontButtonColor: '#DC241F',
      buttonColor: '#fff',
      nextButtonColor: '#DC241F',
      nextButtonFont: '#fff',
      backButtonFont: '#DC241F',
      backButtonColor: '#fff',
      bannerBackgroundColor: '#DC241F',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#DC241F',
      cancelMessageFontType: 'lato',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },

    {
      name: 'LAND ROVER',
      logo: 'Range-logo.png',
      sublogo: 'Range-sublogo.png',
      primaryColor: '#005A2B',
      secondaryColor: '#005A2B',
      tertiaryColor: '#0C121C',
      neutralColor: '#E4E8E8',
      imagen_banner: '/assets/Range-banner-1.png',
      imagen_banner2: '/assets/Range-banner-1.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: '/assets/fonts/HurmeGeometricSans1 Bold.ttf',
      StyleLookAndFeel: 'Style2',
      FontColor: '#0C121C',
      SecundaryFontType: '/assets/fonts/HurmeGeometricSans1-Bold.ttf',
      button2: '#0C121C',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#005A2B',
      buttonClearBorder: '#005A2B',
      buttonSearch: '#0C121C',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '',
      buttonBackgroundColor: '#E9ECECE4',
      fontButtonColor: '#005A2B',
      buttonColor: '',
      nextButtonColor: '#0C121C',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#FFFFFF',
      backButtonColor: '#0C121C',
      bannerBackgroundColor: '#E4E8E8',
      bannerBackgroundColorText: '#0C121C',
      cancelBackButtonBackground: '#E4E8E8',
      cancelBackButtonText: '#005A2B',
      cancelMessageFontType: '/assets/fonts/HurmeGeometricSans1 Bold.ttf',
      fontTypeCardMyReservation: '',
    },
    {
      name: 'MERCEDES BENZ',
      logo: 'mercedes_logo.png',
      sublogo: 'mercedes_logo.png',
      primaryColor: '#0078D6',
      secondaryColor: '#0078D6',
      tertiaryColor: '#000000',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/mercedes_banner.png',
      imagen_banner2: '/assets/mercedes_banner_2.jpg',
      radius: '1.8rem',
      radiuscontainer: '0px',
      FontType: 'MBCorpoATitleCondOffice-Regular',
      StyleLookAndFeel: 'Style1',
      FontColor: '#0078D6',
      SecundaryFontType: 'MBCorpoSTextOffice-Regular',
      button2: '#0078D6',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#0078D6',
      buttonClearBorder: '#0078D6',
      buttonSearch: '#0078D6',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#0078D6',
      buttonBackgroundColor: '#FFFFFF',
      fontButtonColor: '#0078D6',
      buttonColor: '',
      nextButtonColor: '#0078D6',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#FFFFFF',
      backButtonColor: '#0078D6',
      bannerBackgroundColor: '#000000',
      bannerBackgroundColorText: '#fff',
      cancelBackButtonBackground: '#fff',
      cancelBackButtonText: '#0078D6',
      cancelMessageFontType: 'MBCorpoSTextOffice-Light',
      fontTypeCardMyReservation: 'MBCorpoSTextOffice-Regular',
    },
  ];

  //start look and feel Incadea webview

  public webviewIncadea: LookAndFeelWebView[] = [
    {
      name: '',
      logo: '',
      sublogo: '',
      primaryColor: '',
      secondaryColor: '',
      tertiaryColor: '',
      neutralColor: '',
      imagen_banner: '',
      imagen_banner2: '',
      radius: '',
      radiuscontainer: '',
      FontType: '',
      StyleLookAndFeel: '',
      FontColor: '',
      SecundaryFontType: '',
      button2: '',
      buttonClear: '',
      buttonClearFontColor: '',
      buttonClearBorder: '',
      buttonSearch: '',
      buttonSearchBorder: '',
      buttonSearchFontColor: '',
      buttonBorderColor: '',
      buttonBackgroundColor: '',
      fontButtonColor: '',
      buttonColor: '',
      nextButtonColor: '',
      nextButtonFont: '',
      backButtonFont: '',
      backButtonColor: '',
      bannerBackgroundColor: '',
      bannerBackgroundColorText: '',
      cancelBackButtonBackground: '',
      cancelBackButtonText: '',
      cancelMessageFontType: '',
      fontTypeCardMyReservation: '',
    },

    {
      name: 'SUZUKI',
      logo: 'suzuki-logo.png',
      sublogo: 'suzuki-logo.png',
      primaryColor: '#DE0039',
      secondaryColor: '#DE0039',
      tertiaryColor: '#62686B',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/suzuki-banner-1.png',
      imagen_banner2: '/assets/suzuki-banner-2.png',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'SuzukiPROBold',
      StyleLookAndFeel: 'Style1',
      FontColor: '#fff',
      SecundaryFontType: 'SuzukiPRORegular',
      button2: '#DE0039',
      buttonClear: '#fff',
      buttonClearFontColor: '#DE0039',
      buttonClearBorder: '#DE0039',
      buttonSearch: '#DE0039',
      buttonSearchBorder: '#DE0039',
      buttonSearchFontColor: '#fff',
      buttonBorderColor: '#DE0039',
      buttonBackgroundColor: '#fff',
      fontButtonColor: '#DE0039',
      buttonColor: '#fff',
      nextButtonColor: '#DE0039',
      nextButtonFont: '#fff',
      backButtonFont: '#DE0039',
      backButtonColor: '#fff',
      bannerBackgroundColor: '#DE0039',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#DE0039',
      cancelMessageFontType: 'SuzukiPROBold',
      fontTypeCardMyReservation: 'SuzukiPRORegular',
    },

    {
      name: 'CHANGAN AUTO',
      logo: 'changan-logo.svg',
      sublogo: 'changan-sublogo.svg',
      primaryColor: '#0B457F',
      secondaryColor: '#152F54',
      tertiaryColor: '#62686B',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/changan-banner-1.jpg',
      imagen_banner2: '/assets/changan-banner-2.jpg',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'TitilliumWeb-Bold',
      StyleLookAndFeel: 'Style1',
      FontColor: '#fff',
      SecundaryFontType: 'TitilliumWeb-Regular',
      button2: '#0B457F',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#0B457F',
      buttonClearBorder: '#0B457F',
      buttonSearch: '#0B457F',
      buttonSearchBorder: '#0B457F',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#0B457F',
      buttonBackgroundColor: '#FFFFFF',
      fontButtonColor: '#0B457F',
      buttonColor: '',
      nextButtonColor: '#0B457F',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#0B457F',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#0B457F',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#0B457F',
      cancelMessageFontType: 'TitilliumWeb-Bold',
      fontTypeCardMyReservation: 'TitilliumWeb-Regular',
    },

    {
      name: 'JAC',
      logo: 'jac-logo.svg',
      sublogo: 'jac-sublogo.svg',
      primaryColor: '#CC010C',
      secondaryColor: '#CC010C',
      tertiaryColor: '#ECB5B8',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/JacBannerMArketChange.jpg',
      imagen_banner2: '/assets/JacBannerMArketChange.jpg',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'Hurme Geometric Sans 3 Bold',
      StyleLookAndFeel: 'Style1',
      FontColor: '#fff',
      SecundaryFontType: 'Hurme Geometric Sans 3',
      button2: '#CC010C',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#CC010C',
      buttonClearBorder: '#CC010C',
      buttonSearch: '#CC010C',
      buttonSearchBorder: '#CC010C',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#CC010C',
      buttonBackgroundColor: '#FFFFFF',
      fontButtonColor: '#CC010C',
      buttonColor: '',
      nextButtonColor: '#CC010C',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#CC010C',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#CC010C',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#CC010C',
      cancelMessageFontType: 'HurmeGeometricSans1 Bold',
      fontTypeCardMyReservation: 'Hurme Geometric Sans 3',
    },

    {
      name: 'Geely',
      logo: 'Geely-logo.png',
      sublogo: 'Geely-sublogo.png',
      primaryColor: '#002D96',
      secondaryColor: '#002D96',
      tertiaryColor: '#002D96#002D96',
      neutralColor: '#FFFFFF',
      imagen_banner: '/assets/Geely-banner-1.png',
      imagen_banner2: '/assets/Geely-banner-2.jpg',
      radius: '0rem',
      radiuscontainer: '0rem',
      FontType: '/assets/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType:
        '/assets/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
      button2: '',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#002D96',
      buttonClearBorder: '#002D96',
      buttonSearch: '#002D96',
      buttonSearchBorder: '#002D96',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#002D96',
      buttonBackgroundColor: '#FFFFFF',
      fontButtonColor: '#002D96',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#002D96',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#002D96',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#002D96',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#002D96',
      cancelMessageFontType:
        '/assets/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
      fontTypeCardMyReservation:
        '/assets/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
    },
    {
      name: 'Subaru',
      logo: 'subaru-logo.png',
      sublogo: 'subaru-sublogo.png',
      primaryColor: '#00A0DC',
      secondaryColor: '#00A0DC',
      tertiaryColor: '#CCE9FF',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/imgBanner.png',
      imagen_banner2: '/assets/img-banner-subaru2.png',
      radius: '0rem',
      radiuscontainer: '0rem',
      FontType: 'Avenir Next LT Pro',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'Avenir Next LT Pro',
      button2: '',
      buttonClear: '#00A0DC',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#00A0DC',
      buttonSearch: '#00A0DC',
      buttonSearchBorder: '#00A0DC',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#00A0DC',
      buttonBackgroundColor: '#00A0DC',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#00A0DC',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#00A0DC',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#00A0DC',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#00A0DC',
      cancelMessageFontType: 'Avenir Next LT Pro',
      fontTypeCardMyReservation: 'Avenir Next LT Pro',
    },

    {
      name: 'DFSK',
      logo: 'dfsk-logo.png',
      sublogo: 'dfsk-sublogo.png',
      primaryColor: '#BF0811',
      secondaryColor: '#BF0811',
      tertiaryColor: '#ECB5B8',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/imagen_banner_dfsk.png',
      imagen_banner2: '/assets/Dfsk-banner-2.jpg',
      radius: '0rem',
      radiuscontainer: '0px',
      FontType: 'Montserrat-Regular',
      StyleLookAndFeel: 'Style1',
      FontColor: '#FFFFFF',
      SecundaryFontType: 'Montserrat-Regular',
      button2: '',
      buttonClear: '#666666',
      buttonClearFontColor: '#FFFFFF',
      buttonClearBorder: '#666666',
      buttonSearch: '#BF0811',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#666666',
      buttonBackgroundColor: '#666666',
      fontButtonColor: '#FFFFFF',
      buttonColor: '#FFFFFF',
      nextButtonColor: '#BF0811',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#BF0811',
      backButtonColor: '#FFFFFF',
      bannerBackgroundColor: '#BF0811',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#666666',
      cancelBackButtonText: '#FFFFFF',
      cancelMessageFontType: 'Montserrat-Regular',
      fontTypeCardMyReservation: 'Montserrat-Regular',
    },

    {
      name: 'MERCEDES BENZ',
      logo: 'mercedes_logo.png',
      sublogo: 'mercedes_logo.png',
      primaryColor: '#0078D6',
      secondaryColor: '#0078D6',
      tertiaryColor: '#000000',
      neutralColor: '#F7F7F7',
      imagen_banner: '/assets/mercedes_banner.png',
      imagen_banner2: '/assets/mercedes_banner_2.jpg',
      radius: '1.8rem',
      radiuscontainer: '0px',
      FontType: 'MBCorpoATitleCondOffice-Regular',
      StyleLookAndFeel: 'Style1',
      FontColor: '#0078D6',
      SecundaryFontType: 'MBCorpoSTextOffice-Regular',
      button2: '#0078D6',
      buttonClear: '#FFFFFF',
      buttonClearFontColor: '#0078D6',
      buttonClearBorder: '#0078D6',
      buttonSearch: '#0078D6',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#FFFFFF',
      buttonBorderColor: '#0078D6',
      buttonBackgroundColor: '#FFFFFF',
      fontButtonColor: '#0078D6',
      buttonColor: '',
      nextButtonColor: '#0078D6',
      nextButtonFont: '#FFFFFF',
      backButtonFont: '#FFFFFF',
      backButtonColor: '#0078D6',
      bannerBackgroundColor: '#000000',
      bannerBackgroundColorText: '#fff',
      cancelBackButtonBackground: '#fff',
      cancelBackButtonText: '#0078D6',
      cancelMessageFontType: 'MBCorpoSTextOffice-Light',
      fontTypeCardMyReservation: 'MBCorpoSTextOffice-Regular',
    },
    {
      name: 'DERCO',
      logo: 'derco-logo.svg',
      sublogo: 'derco-sublogo.svg',
      primaryColor: '#DC241F',
      secondaryColor: '#DC241F',
      tertiaryColor: '#62686B',
      neutralColor: '#F1F1F1',
      imagen_banner: '/assets/derco_banner_1.jpg',
      imagen_banner2: '/assets/derco_banner_2.png',
      radius: '0.5rem',
      radiuscontainer: '0px',
      FontType: 'lato',
      StyleLookAndFeel: 'Style1',
      FontColor: '#fff',
      SecundaryFontType: 'lato',
      button2: '#DC241F',
      buttonClear: '#fff',
      buttonClearFontColor: '#DC241F',
      buttonClearBorder: '#DC241F',
      buttonSearch: '#DC241F',
      buttonSearchBorder: '',
      buttonSearchFontColor: '#fff',
      buttonBorderColor: '#DC241F',
      buttonBackgroundColor: '#fff',
      fontButtonColor: '#DC241F',
      buttonColor: '#fff',
      nextButtonColor: '#DC241F',
      nextButtonFont: '#fff',
      backButtonFont: '#DC241F',
      backButtonColor: '#fff',
      bannerBackgroundColor: '#DC241F',
      bannerBackgroundColorText: '#FFFFFF',
      cancelBackButtonBackground: '#FFFFFF',
      cancelBackButtonText: '#DC241F',
      cancelMessageFontType: 'lato',
      fontTypeCardMyReservation: 'lato',
    },
  ];
}
